<template>
  <div class="wrap-loading">
    <div
      v-for="i in 8"
      :key="`block-${i}`"
      :class="{'mobile': isMobile}"
      class="summary-block"
    />
  </div>
</template>

<script>
export default {
  props: {
    isWorkflow: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
  .wrap-loading {
    width: 100%;
    display: flex;
    overflow-x: auto;
    padding-bottom: 15px;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      height: 4px;
    }

    .summary-block {
      width: 182px;
      min-width: 182px;
      height: 63px;
      border-radius: 7px;
      background-color: #ECECEC;
      margin-right: 6px;

      &.mobile {
        height: 55px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/loading/jSkeletonSummaryBlock.vue